<button mat-raised-button class="cta-button" [disabled]="isProcessing">
  {{ (isProcessing ? 'priceUi.processing' : 'priceUi.unlock') | translate }}
</button>
